import StonecodeFileTypeSourceModel from '@models/website/StonecodeFileTypeSourceModel';
import StonecodeFileMimeTypeModel   from '@models/website/StonecodeFileMimeTypeModel';
import StonecodeFileFileStatusModel from '@models/website/StonecodeFileFileStatusModel';
import doc                          from '@widesk-core/decorators/doc';
import WebsiteServiceModel          from '@/models/WebsiteServiceModel';
import Blamable                     from '@/models/traits/Blamable';
import { Addable }                  from '@widesk-core/decorators/addable';
import { Editable }                 from '@widesk-core/decorators/editable';
import { Deletable }                from '@widesk-core/decorators/deletable';
import { Timestampable }            from '@widesk-core/decorators/timestampable';

@doc.path('/stonecode_file_files/{?id}')
@doc.addable
@doc.editable
@doc.deletable
@doc.timestampable
abstract class AbstractStonecodeFileFileModel extends Blamable(
	WebsiteServiceModel,
) {
	declare protected _tsFilters: {
		'partial': string;
		'createdBy': id;
		'typeSource': id;
		'typeSource.type': id;
		'typeSource.type.service': id;
		'typeSource.type.service.serviceUrn': Urn;
		'typeSource.type.reference': Website_StonecodeFileTypeReference;
		'typeSource.source': id;
		'typeSource.source.entityUrn': Urn;
		'fileTypeVisibilities': id;
		'fileTypeVisibilities.typeVisibility': id;
		'fileTypeVisibilities.typeVisibility.visibility': id;
		'fileTypeVisibilities.typeVisibility.visibility.reference': Website_StonecodeFileVisibilityReference;
		'fileStatus': id;
		'fileStatus.reference': Website_StonecodeFileFileStatusReference;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
	};

	declare private _tsSorts: {
		id: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.model(StonecodeFileTypeSourceModel)
	declare typeSource: StonecodeFileTypeSourceModel;
	@doc.model(StonecodeFileMimeTypeModel)
	declare mimeType: StonecodeFileMimeTypeModel;
	@doc.string declare label: string;
	@doc.string declare name: string;
	@doc.string declare description: string;
	@doc.number declare size: number;
	@doc.date declare date: Dayjs;
	@doc.model(StonecodeFileFileStatusModel)
	declare fileStatus: StonecodeFileFileStatusModel;
	@doc.boolean declare public: boolean;
}

interface AbstractStonecodeFileFileModel
	extends Addable,
		Editable,
		Deletable,
		Timestampable {}

export default AbstractStonecodeFileFileModel;
